export class ThreeDModels {
  public static BGL = 'assets/3D/BGL.stl';
  public static BOX = 'assets/3D/box.stl';
  public static BSR = 'assets/3D/BSR.stl';
  public static CONE = 'assets/3D/cone.stl';
  public static CYLINDER = 'assets/3D/cylinder.stl';
  public static FJ = 'assets/3D/FJ.stl';
  public static MONO_BR = 'assets/3D/MonoBR.stl';
  public static MONOBUOY = 'assets/3D/monobuoy.stl';
  public static P40 = 'assets/3D/P40.stl';
  public static P52 = 'assets/3D/P52.stl';
  public static SHIP = 'assets/3D/ship.glb';
  public static PLAT = 'assets/3D/plat.glb';
  public static SPHERE = 'assets/3D/sphere.stl';
  public static SUP_EXT = 'assets/3D/Sup_Ext.stl';
  public static SUP_INT = 'assets/3D/Sup_Int.stl';
  public static TIANG_PRISM = 'assets/3D/tiang_prism.stl';
  public static TUGBOAT = 'assets/3D/tugboat.stl';
}
